module.exports = __webpack_public_path__ + "img/branco.f85d2ea1.svg";